import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import * as actions from '../../state/actions'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router'
import Spinner from '../common/Spinner'
import List from '../common/List'
import {Button, ButtonToolbar, Nav, NavItem, Badge, FormGroup} from 'react-bootstrap'
import style from './styles.less'
import moment from 'moment'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'
import momentLocalizer from 'react-widgets/lib/localizers/moment'

class Transactions extends Component {

    constructor(props) {
        super(props)
        let self = this
        let columns = ['Fecha', 'Email del cliente', 'Producto', 'Monto', 'Acciones']

        if (self.props.params.subscriptionId) {
            columns = ['Fecha', 'Producto', 'Monto', 'Acciones']
        }
        let query = {
            status: 'paid'
        }
        if (self.props.params.subscriptionId) {
            query = {
                status: 'paid',
                subscription: self.props.params.subscriptionId
            }
        } else if (self.props.params.entityId) {
            query = {
                status: 'paid',
                'entity.externalId': self.props.params.entityId
            }
        }
        self.state = {
            dataColumnsNames: columns,
            loading: true,
            selectedKey: 'paid',
            filter: {
                query: query,
                sort: {
                    createdAt: 1
                }
            },
            isFilters: false,
            from: null,
            to: null
        }

        momentLocalizer(moment)
        this.handleSubmit = this.handleSubmit.bind(this)

        self.props.actions.transactionsGet = self.props.actions.transactionsGet.bind(self, self.props.params.appCodename)
        self.props.actions.transactionsClean = self.props.actions.transactionsClean.bind(self)
        self.props.actions.cancelSaveup = self.props.actions.cancelSaveup.bind(self)
    }

    componentWillMount() {
        let self = this
        let promise = Promise.resolve()

        promise = promise.then(() => {
            var filter = Object.assign({}, self.state.filter)
            var location = self.props.routing && (self.props.routing.location || self.props.routing.locationBeforeTransitions)
            if (location && location.query && location.query.status && (location.query.status === 'paid' || location.query.status === 'pending' || location.query.status === 'rejected' || location.query.status === 'saveup' || location.query.status === 'created')) {
                filter.query = { 'status': location.query.status }
                filter.sort = { createdAt: 1 }
                this.setState({ filter, selectedKey: location.query.status })

                if (location.query.status === 'rejected' || location.query.status === 'pending') {
                    let columns = ['Fecha', 'Email del cliente', 'Producto', 'Monto', 'Detalle del estado', 'Acciones']
                    if (self.props.params.subscriptionId) {
                        columns = ['Fecha', 'Producto', 'Monto', 'Detalle del estado', 'Acciones']
                    }
                    self.setState({ dataColumnsNames: columns })
                }
            }
            self.setState({ loading: false })
            return Promise.resolve()
        })

        return promise
    }

    componentWillUpdate(nextProps, nextState) {
        let self = this
        if (self.props.location && self.props.location.query && self.props.location.query.status && nextProps[self.props.location.query.status] > self.props[self.props.location.query.status]) {
            self.refreshData(true)
        }
    }

    refreshData(useSkip) {
        let self = this

        if (self.list) {
            let list = self.list.getWrappedInstance()
            return list.refreshData(false)
        }

        return Promise.resolve()
    }

    cancelSaveup(data) {
        let self = this
        self.props.actions.cancelSaveup(self.props.params.appCodename, data).then(function(result) {
            return self.refreshData(true).then(() => {
                self.setState({ loading: false })
            })
        })
    }

    changeStatus(status) {
        let self = this
        let filter = Object.assign({}, self.state.filter)
        filter.query.status = status
        let columns = ['Fecha', 'Email del cliente', 'Producto', 'Monto', 'Acciones']
        if (self.props.params.subscriptionId) {
            columns = ['Fecha', 'Producto', 'Monto', 'Acciones']
        }
        if (status === 'rejected' || status === 'pending') {
            columns = ['Fecha', 'Email del cliente', 'Producto', 'Monto', 'Detalle del estado', 'Acciones']
            if (self.props.params.subscriptionId) {
                columns = ['Fecha', 'Producto', 'Monto', 'Detalle del estado', 'Acciones']
            }
            self.setState({ dataColumnsNames: columns })
        }
        self.setState({ selectedKey: status, filter, dataColumnsNames: columns })
        self.refreshData(false)
    }

    handleSubmit(event) {
        event.preventDefault()
        let self = this
        let filter = Object.assign({}, self.state.filter)
        let isFilters = true
        if (self.state.from && self.state.to) {
            filter.query.createdAt = { $gte: moment.utc(self.state.from).startOf('day').toISOString(), $lt: moment.utc(self.state.to).add(1, 'day').startOf('day').toISOString() }
        } else if (self.state.from || self.state.to) {
            if (self.state.from) {
                filter.query.createdAt = { $gte: moment.utc(self.state.from).startOf('day').toISOString(), $lt: moment.utc(self.state.from).add(1, 'day').startOf('day').toISOString() }
            } else {
                filter.query.createdAt = { $gte: moment.utc(self.state.to).startOf('day').toISOString(), $lt: moment.utc(self.state.to).add(1, 'day').startOf('day').toISOString() }
            }
        } else {
            isFilters = false
            delete filter.query.createdAt
        }
        self.setState({ filter: filter, isFilters: isFilters })
        self.refreshData(false)
    }

    dataObjectProcess(transaction) {
        let self = this
        let appCodename = self.props.params.appCodename
        let row = []

        var dateTime = new Date(transaction.createdAt)
        dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
        let emailCustomer = (transaction.customer && transaction.customer.email) ? transaction.customer.email : '-'
        let productName = (transaction.product && transaction.product.name) ? transaction.product.name : ''
        let productExternalId = (transaction.product && transaction.product.externalId) ? transaction.product.externalId : ''
        let productAmount = (transaction.product && transaction.product.amount) ? '$' + transaction.product.amount : ''
        var status = transaction.status ? transaction.status : '-'
        var statusDetail = (transaction.payment && transaction.payment.detail) ? transaction.payment.detail : '-'
        let producto
        if (productName !== '') {
            producto = productName + '\n'
        }
        if (productExternalId !== '') {
            producto += productExternalId
        }
        row.push(
            <div>{dateTime}</div>
        )
        if (!self.props.params.subscriptionId) {
            row.push(
                <div>{emailCustomer}</div>
            )
        }
        row.push(
            <div className={style.text}>{producto}</div>
        )
        row.push(
            <div>{productAmount}</div>
        )
        if (status === 'rejected' || status === 'pending') {
            row.push(
                <div>{statusDetail}</div>
            )
        }
        if (self.props.params.subscriptionId) {
            row.push(
                <ButtonToolbar>
                    <Link to={`/manager/${appCodename}/subscriptions/${self.props.params.subscriptionId}/transactions/detail/${transaction._id}`} type="button" className="btn btn-default">
                        <i className="fa fa-eye" aria-hidden="true"></i>
                    </Link>
                </ButtonToolbar>
            )
        } else if (self.props.params.entityId) {
            row.push(
                <ButtonToolbar>
                    <Link to={`/manager/${appCodename}/entity/${self.props.params.entityId}/transactions/detail/${transaction._id}`} type="button" className="btn btn-default">
                        <i className="fa fa-eye" aria-hidden="true"></i>
                    </Link>
                </ButtonToolbar>
            )
        } else if (status === 'pending' || status === 'saveup') {
            row.push(
                <ButtonToolbar>
                    <Link to={`/manager/${appCodename}/transactions/detail/${transaction._id}`} type="button" className="btn btn-default">
                        <i className="fa fa-eye" aria-hidden="true"></i>
                    </Link>
                    <Button onClick={self.cancelSaveup.bind(self, transaction._id)} type="button" className="btn btn-default">
                        <span className="fa fa-ban" aria-hidden="true" ></span>
                    </Button>
                </ButtonToolbar>
            )
        } else {
            row.push(
                <ButtonToolbar>
                    <Link to={`/manager/${appCodename}/transactions/detail/${transaction._id}`} type="button" className="btn btn-default">
                        <i className="fa fa-eye" aria-hidden="true"></i>
                    </Link>
                </ButtonToolbar>
            )
        }
        return row
    }

    descargarRegistro() {
        let self = this
        self.setState({ loading: true, statusAlert: false, statusText: false })
        let query = {}
        let from, to

        if (self.state.from) {
            from = moment.utc(self.state.from).startOf('day').toISOString()
            to = moment.utc(self.state.from).add(1, 'day').startOf('day').toISOString()
        }
        if (self.state.to) {
            to = moment.utc(self.state.to).add(1, 'day').startOf('day').toISOString()
            if (!self.state.from) {
                from = moment.utc(self.state.to).startOf('day').toISOString()
            }
        }
        if (from || to) {
            query.createdAt = {}
            if (from) {
                query.createdAt['$gte'] = from
            }
            if (to) {
                query.createdAt['$lt'] = to
            }
        }
        query.status = self.props.location.query.status
        self.props.actions.transactionsDescargarCsv(self.props.params.appCodename, query).then(res => {
            if (res && res.payload && res.payload.data && res.payload.status >= 200 && res.payload.status < 300) {
                var blob = new Blob([res.payload.data], { type: 'text/csv;charset=utf-8;' })
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, 'registro.csv')
                } else {
                    var link = document.createElement('a')
                    if (link.download !== undefined) {
                        var url = URL.createObjectURL(blob)
                        link.setAttribute('href', url)
                        link.setAttribute('download', 'transactions.csv')
                        link.style.visibility = 'hidden'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                    }
                }
            }
            self.setState({ loading: false })
        })
    }

    render() {
        let self = this
        let content
        let itemsProcessed = []

        if (self.props.transactions && self.props.profile && self.props.profile.profile >= 500 && self.props.transactions.length) {
            self.props.transactions.forEach(function(query) {
                itemsProcessed.push(self.dataObjectProcess(query))
            })
        }

        let listHeader = (
            <Nav className={style.processNavbar} bsStyle="tabs" activeKey={self.state.selectedKey} onSelect={self.changeStatus.bind(self)}>
                <NavItem key={'paid-' + self.props.paid} eventKey={'paid'} title="paid">Pagadas <Badge>{self.props.paid}</Badge></NavItem>
                <NavItem key={'pending-' + self.props.pending} eventKey={'pending'} title="pending">Pendientes <Badge>{self.props.pending}</Badge></NavItem>
                <NavItem key={'rejected-' + self.props.rejected} eventKey={'rejected'} title="rejected">Rechazadas <Badge>{self.props.rejected}</Badge></NavItem>
                <NavItem key={'saveup-' + self.props.saveup} eventKey={'saveup'} title="saveup">Save up <Badge>{self.props.saveup}</Badge></NavItem>
                <NavItem key={'created-' + self.props.created} eventKey={'created'} title="created">Creadas <Badge>{self.props.created}</Badge></NavItem>
            </Nav>
        )

        let description = false
        if (self.props.profile.profile >= 1000) {
            description = (
                <div>
                    <div className="row">
                        <form className="col-xs-12" onSubmit={this.handleSubmit}>
                            <br/>
                            <div className="row">
                                <div className="col-md-3">
                                    <FormGroup>
                                        <DateTimePicker name="from" culture="es" time={false} placeholder="Desde..." value={self.state.from} max={self.state.to ? new Date(self.state.to) : new Date()} onChange={(value) => { self.setState({ from: value }) }} />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <DateTimePicker name="to" culture="es" time={false} placeholder="Hasta..." value={self.state.to} min={self.state.from ? new Date(self.state.from) : undefined} max={new Date()} onChange={(value) => { self.setState({ to: value }) }} />
                                    </FormGroup>
                                </div>
                                <div className="col-md-1">
                                    <Button type="submit" className="pull-right">Filtrar</Button>
                                </div>
                                <div style={ (self.state.isFilters && self.props.transactions && self.props.transactions.length) ? { display: '' } : { display: 'none' }} className='col-xs-5 col-md-2'>
                                    <Button disabled={ self.state.loading } onClick={self.descargarRegistro.bind(self)}><span className="fa fa-download fa-fw"></span> Descargar csv</Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )
        }

        if (self.state.loading) {
            content = <Spinner />
        } else {
            let name = 'Transacciones'
            if (self.props.params.subscriptionId && self.props.transactions && self.props.transactions[0] && self.props.transactions[0].customer && self.props.transactions[0].customer.email) {
                name = 'Transacciones de ' + self.props.transactions[0].customer.email
            }
            content = <List
                        ref={(list) => { this.list = list }}
                        name={name}
                        items={itemsProcessed}
                        dataColumnsNames={self.state.dataColumnsNames}
                        listHeader={listHeader}
                        description={description}
                        getObjects={self.props.actions.transactionsGet}
                        clearObjects={self.props.actions.transactionsClean}
                        params={self.state.filter}
                        limit={50}
                    />
        }

        return (
            <div>
                {content}
            </div>
        )
    }
}

Transactions.propTypes = {
    paid: PropTypes.number,
    pending: PropTypes.number,
    rejected: PropTypes.number,
    saveup: PropTypes.number,
    created: PropTypes.number
}

function mapStateToProps(state) {
    return {
        transactions: state.transactions,
        routing: state.routing,
        profile: state.profile
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Transactions)



// WEBPACK FOOTER //
// ./components/Transactions/index.js